<template>
    <div class="calendar-cell calendar-tech-cell">
        <div class="flex justify-between h-full" :class="extended ? 'items-start' : 'items-center'">
            <div class="flex items-center">
                <div class="creator-cube" :class="technician.is_active ? 'success' : 'danger'">
                    <md-tooltip md-direction="top" style="min-width: max-content !important;">
                        {{ technician.is_active ? 'Actif' : 'Inactif' }}
                    </md-tooltip>
                </div>
                <span class="ml-2 font-medium">{{ technician.first_name }}</span>
            </div>
            <div>
                <md-button class="md-icon-button md-small-icon md-rounded-icon my-0"
                           :class="extended ? 'md-danger': 'md-success'" @click="extendRow">
                    <font-awesome-icon class="md-icon" :icon="['fa', extended ? 'minus': 'plus']" />
                </md-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CalendarTechnicianCell",
    props: {
        technician: Object,
        extended: Boolean
    },
    methods: {
        extendRow() {
            this.$emit('extend')
        }
    }
}
</script>

<style scoped lang="scss">
.creator-cube {
    width: 12px;
    height: 12px;
    border-radius: 3px;
    &.success {
        background: $brand-success;
    }
    &.danger {
        background: $brand-danger;
    }
}
</style>
